import { render, staticRenderFns } from "./card-random.vue?vue&type=template&id=ce3a58b4&scoped=true"
import script from "./card-random.vue?vue&type=script&lang=js"
export * from "./card-random.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3a58b4",
  null
  
)

export default component.exports